import type { CSSProperties } from 'react'
import './Header.css'
import { ClassName, cx } from '@/utils/cx'

interface HeaderProps {
  children: React.ReactNode
  flexSpaceBetween?: boolean
  style?: CSSProperties
  className?: ClassName
}

export const Header = ({ children, flexSpaceBetween, style, className }: HeaderProps) => (
  <h1
    className={cx(
      'header__container',
      'onboarding-header',
      flexSpaceBetween && 'header__flex-space-between',
      className
    )}
    style={style}
  >
    {children}
  </h1>
)
